<template>
    <iframe class="gui-pdf-preview" :src="`${pdfjsUrl}?file=${baseService}/basiceg/v1/bytes/${pdfFileUrl}&w=${warterMark}`" frameborder="0"></iframe>
  </template>
  
  <script>
  export default {
    name  : "PdfPreview",
    props : {
      /*预览文件地址*/
      pdfFileUrl : {
        type    : String,
        defalut : ""
      },
      /*水印文字*/
      warterMark  : {
        type    : String,
        default : ""
      },
      /*pdfjs访问路径*/
      pdfjsUrl    : {
        type    : String,
        default : ""
      }
    },
    data(){
      return {
        baseService     : ""
      }
    },
    created() {
      this.baseService  = config.serverUrl;
      // console.log( encodeURIComponent( `${this.baseService}/cmss/v1/comp-service/api/send?url=${this.baseService}/basiceg/v1/bytes/${this.pdfFileUrl}` ) );
      // debugger
    }
  }
  </script>
  
  <style lang="less" scoped>
  .gui-pdf-preview{
    width:100%;
    height:100%;
  }
  
  </style>
  